import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DonVi} from '../../../models/danhmuc/donvi';
import {DonViService} from '../../../service/danhmuc/service-donvi';
import {TreeViewComponent} from '@syncfusion/ej2-angular-navigations';
import {Staffs} from '../../../models/staff/staffs';
import {StaffsService} from '../../../service/staff/service-staffs';
import {WorkGroupsService} from '../../../service/staff/service-workgroups';
import {Sessioncommand} from '../../../global/sessioncommand';
import {WorkGroups} from '../../../models/staff/workgroups';
import {GroupInnerComponent} from '../groupother/groupinner.component';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';

@Component({
  templateUrl: './chuyendv.component.html'

})
export class ChuyenDonViComponent implements OnInit, AfterViewInit {
  public language = language;
  public onClose: Subject<boolean>;
  public selectStaffs: Subject<Staffs[]>;
  public showCheckBox: boolean = true;
  public dataTree: DonVi[];
  public dataTreeGroup: WorkGroups[];
  public dataDonVi: Object[] = [];
  public dataGroup: Object[] = [];
  public fieldTree: Object;
  public fieldTreeGroup: Object;
  public slGroupId: string = "slGroupId";
  public dataStaffTree: Staffs[];
  public dataStaffsList: Object[] = [];
  public fieldStaffTree: Object;
  public selectStaffCheck: Object[] = [];
  public staffId: number = Sessioncommand.staffId;
  @ViewChild("sgEditStaffs")
  public selectGroup: GroupInnerComponent;

  public dataStaffs: Staffs[];
  @ViewChild('treeview') public tree: TreeViewComponent;
  @ViewChild('treeviewgroup') public treeGroup: TreeViewComponent;
  @ViewChild('treeviewStaffs') public treeStaffs: TreeViewComponent;

  constructor(public toastr: ToastrService,
              public _bsModalRef: BsModalRef,
              public donViService: DonViService,
              public staffService: StaffsService,
              public bsModalService: BsModalService,
              public workGroupsService: WorkGroupsService
  ) {
  }

  ngAfterViewInit() {

  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.selectStaffs = new Subject();
  }

  public showDonVi(): void {

    this.donViService.getAll().subscribe(x => {
      this.dataTree = x;
      this.dataDonVi = [];
      for (let i = 0; i < this.dataTree.length; i++) {
        this.dataDonVi.push(
          this.dataTree[i].maCapTren == 0 ?
            {
              id: this.dataTree[i].id,
              name: this.dataTree[i].tenCQ,
              hasChild: this.dataTree[i].hasChild,
              expanded: true
            }
            :
            {
              id: this.dataTree[i].id,
              pid: this.dataTree[i].maCapTren,
              name: this.dataTree[i].tenCQ,
              hasChild: this.dataTree[i].hasChild,
              expanded: false
            });
      }
      this.fieldTree = {dataSource: this.dataDonVi, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild'};

    });
    this.workGroupsService.findByKeyword('', this.staffId).subscribe(x =>{
      this.dataTreeGroup = x;
      this.dataGroup = [];

      for (let i = 0; i < this.dataTreeGroup.length; i++) {
        this.dataGroup.push(
          { id: this.dataTreeGroup[i].id,
            name: this.dataTreeGroup[i].tenNhom,
            hasChild: false,
            expanded: true
          }
        );
      }
      this.fieldTreeGroup = {dataSource: this.dataGroup, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild'};
    });
  }
  public showTreeStaffs(sid: string): void {
    this.staffService.findAllByDonViId(sid).subscribe(x => {
      this.dataStaffTree = x;
      this.dataStaffsList = [];
      this.dataStaffsList.push(
        {
          id: 0,
          name: language.danhsachchon,
          hasChild: true,
          expanded: true
        }
      );
      for (let i = 0; i < this.dataStaffTree.length; i++) {
        this.dataStaffsList.push(
          {
            id: this.dataStaffTree[i].id,
            pid: 0,
            name: this.dataStaffTree[i].hoDem + ' ' + this.dataStaffTree[i].ten +'('+this.dataStaffTree[i].chucVuItem.tenChucVu+')',
            hasChild: true,
            isChecked: (this.selectStaffCheck.some(e => e["id"] ===this.dataStaffTree[i].id)==false? false: true),
            expanded: false
          });
      }
      this.fieldStaffTree = {dataSource: this.dataStaffsList, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild', isChecked: 'isChecked' };

    });

  }

  public showTreeGroupStaffs(sid: string): void {
    this.staffService.findAllByWorkGroupId(sid).subscribe(x => {
      this.dataStaffTree = x;
      this.dataStaffsList = [];
      this.dataStaffsList.push(
        {
          id: 0,
          name: language.danhsachchon,
          hasChild: true,
          expanded: true
        }
      );
      for (let i = 0; i < this.dataStaffTree.length; i++) {
        this.dataStaffsList.push(
          {
            id: this.dataStaffTree[i].id,
            pid: 0,
            name: this.dataStaffTree[i].hoDem + ' ' + this.dataStaffTree[i].ten +'('+this.dataStaffTree[i].chucVuItem.tenChucVu+')',
            hasChild: true,
            isChecked: (this.selectStaffCheck.some(e => e["id"] ===this.dataStaffTree[i].id)==false? false: true),
            expanded: false
          });
      }
      this.fieldStaffTree = {dataSource: this.dataStaffsList, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild', isChecked: 'isChecked' };

    });

  }

  public show(id: number) {
  }

  public onSelect(): void {
    let maDonVi: number = Number(this.selectGroup.selectTree.value);
    let staffIds: string = this.treeStaffs.getAllCheckedNodes().join();
    if(maDonVi === 0 ||  staffIds ==='')
        this.toastr.error(language.message_error_donvichuyen, language.message);
    else
    {
        this.changeDonVi(maDonVi, staffIds);
    }
  }
  changeDonVi(id: number, staffIds: string)
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.message_question_donvichuyen ,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.staffService.changeMaDonViByMulti(id, staffIds).subscribe({
          next: () => {
            this.toastr.success(language.message_success_donvichuyen, language.message);
          },
          error: error => {
            this.toastr.error(language.error, language.message);
          }
        });
      }
    });


  }
  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

  public nodeChecked(args): void {
    let arrDV: string = this.tree.getAllCheckedNodes().join();
    this.showTreeStaffs(arrDV);
  }

  public nodeCheckedGroup(args): void {
    let arrGR: string = this.treeGroup.getAllCheckedNodes().join();
    this.showTreeGroupStaffs(arrGR);
  }

  public nodeStaffChecked(args): void {
    let arrStaff: string = this.treeStaffs.getAllCheckedNodes().join();
    //this.staffService.findAllByStaffId(arrStaff).subscribe(dataList => this.dataStaffs = dataList);
  }
}
